import { getAppConfig } from '@client/core/config/get-app-config';

/**
 * Builds HTTP header sent to backend identifying the web client version making
 * the request.
 */
export function buildClientHeader(): Record<string, string> {
  const config = getAppConfig();

  // Shape of object the backend expects identifying a client application
  const header: AppClientHeader = {
    platform: AppClientPlatform.Web,
    version: config.build.sha,
    timestamp: config.build.timestamp,
  };

  return {
    'X-FF-CLIENT': JSON.stringify(header),
  };
}

/**
 * Shape of the HTTP header content sent to the backend that identifies a client.
 */
export interface AppClientHeader {
  // Where requests originate from
  platform: AppClientPlatform;

  // How the client identifies its versioning.
  // For web we use the git sha it was built from because we don't tag releases
  version: string;

  // ISO8601 format like "2025-05-10T16:41:13.842Z"
  timestamp: string;
}

export enum AppClientPlatform {
  Web = 'web',
  WebLegacy = 'web-legacy',
}
